import React from 'react';
import { Archetype } from '@/lib/archetype';
import explorerImg from '@/assets/archetype-explorer.png';
import thinkerImg from '@/assets/archetype-thinker.png';
import dreamerImg from '@/assets/archetype-dreamer.png';
import connectorImg from '@/assets/archetype-connector.png';
import escapistImg from '@/assets/archetype-escapist.png';
import archivistImg from '@/assets/archetype-archivist.png';

interface ArchetypeMascotProps {
  archetype: Archetype;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  pose?: string;
  variant?: 'raw' | 'badge';
  className?: string;
}

const sizeMap = {
  xs: 48,
  sm: 64,
  md: 128,
  lg: 192,
  xl: 256,
};

const archetypeImages: Record<Archetype, string> = {
  Explorer: explorerImg,
  Thinker: thinkerImg,
  Dreamer: dreamerImg,
  Connector: connectorImg,
  Escapist: escapistImg,
  Archivist: archivistImg,
};

export function ArchetypeMascot({ 
  archetype, 
  size = 'md', 
  className = '',
  variant = 'badge',
}: ArchetypeMascotProps) {
  const pixelSize = sizeMap[size];
  const imageSource = archetypeImages[archetype];

  if (variant === 'raw') {
    return (
      <div 
        className={`flex items-center justify-center ${className}`}
        style={{ width: pixelSize, height: pixelSize }}
      >
        <img 
          src={imageSource} 
          alt={`${archetype} archetype mascot`}
          className="w-full h-full object-contain"
        />
      </div>
    );
  }

  return (
    <div 
      className={`flex items-center justify-center rounded-full bg-muted ring-1 ring-border shadow-sm ${className}`}
      style={{ width: pixelSize, height: pixelSize }}
    >
      <img 
        src={imageSource} 
        alt={`${archetype} archetype mascot`}
        className="w-[85%] h-[85%] object-contain"
      />
    </div>
  );
}
